var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tag-filter", class: _vm.rootClasses }, [
    _c(
      "div",
      { staticClass: "tag-filter--chip-collection" },
      [
        _c(
          "div",
          { staticClass: "tag-filter--tag-wrapper tag-filter--chips" },
          _vm._l(_vm.previewItems, function(item, idx) {
            return _c("div", { key: idx, staticClass: "tag-filter--chip" }, [
              _c(
                "a",
                {
                  staticClass: "u-reset chip",
                  class: { chip__active: item.active },
                  attrs: { href: item.path }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.label) +
                      "\n                "
                  )
                ]
              )
            ])
          })
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "trs-simple-fade" } }, [
          _vm.showAllItems
            ? _c(
                "div",
                { staticClass: "tag-filter--tag-wrapper tag-filter--chips" },
                _vm._l(_vm.hiddenItems, function(item, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "tag-filter--chip" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "u-reset chip",
                          class: { chip__active: item.active },
                          attrs: { href: item.path }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.label) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  )
                })
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.items.length > _vm.maxTags
      ? _c("div", { staticClass: "tag-filter--toggle-wrapper" }, [
          _c(
            "button",
            {
              staticClass: "u-reset tag-filter--toggle",
              on: { click: _vm.toggleShowAll }
            },
            [
              _vm.showAllItems
                ? _c("span", [_vm._v(_vm._s(_vm.showLessLabel))])
                : _c("span", [_vm._v(_vm._s(_vm.showAllLabel))]),
              _vm._v(" "),
              _c("base-icon", {
                staticClass: "tag-filter--toggle-icon",
                attrs: { symbol: "chevron-down", size: "small" }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28c56153", { render: render, staticRenderFns: staticRenderFns })
  }
}